import React, { useState, useEffect, useRef, memo } from "react";
import moment from "moment";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { styles } from "./style";
import { MONTHS } from "../../../constants/dayOfWeek";
import { CalendarHeader } from "../CalenderHeader";
import {
  convertToLocalTimezone,
  extractISOString,
} from "../../../utils/dateUtill";
import {
  useDisplayNextMonthCalendar,
  useDisplayPreviousMonthCalendar,
  useGenerateCalendar,
} from "../../../hooks";
import { Loading } from "../../LoadingComponent/Loading";
import { APP_COLORS } from "../../../constants/colors";

export const CalendarView = memo(({ studentId }) => {
  const currentDateUTC = convertToLocalTimezone(new Date());
  const [calendarView, handleCalendarView] = useState();
  const [calendarCurrentMonth, handleCalendarCurrentMonth] = useState(
    currentDateUTC.getMonth(),
  );
  const [calendarCurrentYear, handleCalendarCurrentYear] = useState(
    currentDateUTC.getFullYear(),
  );
  const dateFlags = useRef();
  const displayPreviousMonth = useDisplayPreviousMonthCalendar({
    monthStateHandler: handleCalendarCurrentMonth,
    yearStateHandler: handleCalendarCurrentYear,
  });
  const displayNextMonth = useDisplayNextMonthCalendar({
    currentDateUTC,
    monthStateHandler: handleCalendarCurrentMonth,
    yearStateHandler: handleCalendarCurrentYear,
  });
  const generateCalendar = useGenerateCalendar({
    calendarCurrentMonth,
    calendarCurrentYear,
    currentDateUTC,
    studentId,
  });

  const getDateStyles = (fullDateUTC) => {
    const keyValue = fullDateUTC.split("T")[0];
    const frequencyValue = dateFlags.current[keyValue];

    let backgroundColor = "";
    let textColor = "";

    if (frequencyValue > 0 && frequencyValue < 50) {
      backgroundColor = APP_COLORS.halfCompleted;
      textColor = APP_COLORS.white;
    } else if (frequencyValue >= 50 && frequencyValue < 100) {
      backgroundColor = APP_COLORS.oneCompleted;
      textColor = APP_COLORS.white;
    } else if (frequencyValue === 100) {
      backgroundColor = APP_COLORS.noCompleted;
      textColor = APP_COLORS.white;
    } else if (frequencyValue === 0) {
      backgroundColor = APP_COLORS.successColor;
      textColor = APP_COLORS.white;
    } else {
      backgroundColor = APP_COLORS.dateBackgroundColor;
      textColor = APP_COLORS.black;
    }

    return { DATE_STYLES: { backgroundColor, textColor } };
  };

  const updateCalendar = ({ calendarMatrix }) => {
    const currentDateISO = extractISOString(currentDateUTC);
    let rowKey = -1;
    let colKey = 0;
    const updateCalendarView = calendarMatrix.map((row) => {
      rowKey += 1;
      const calendarRow = row.map((calendarDate) => {
        colKey += 1;
        if (calendarDate === "") {
          return <div style={styles.noDateView} key={colKey} />;
        }
        const calendarUTCDate = new Date(
          calendarCurrentYear,
          calendarCurrentMonth,
          calendarDate,
        );
        const calendarUTCDateISO = extractISOString(calendarUTCDate);
        const isTodaysDate = currentDateISO === calendarUTCDateISO;

        const { DATE_STYLES } = getDateStyles(
          // passing local date to get Frequncy Rate.
          moment(calendarUTCDate).format("YYYY-MM-DD"),
        );

        const todayTextStyle = isTodaysDate ? styles.whiteText : {};

        return (
          <div
            style={{
              ...DATE_STYLES,
              ...styles.dateView,
            }}
            key={colKey}>
            <p
              style={{
                ...styles.dates,
                // ...textStyle,
                ...todayTextStyle,
                color: DATE_STYLES.textColor,
              }}>
              {calendarDate}
            </p>
            {isTodaysDate && <div style={styles.todaysDate} />}
          </div>
        );
      });
      return (
        <div key={rowKey} style={styles.calendarDisplayRow}>
          {calendarRow}
        </div>
      );
    });
    handleCalendarView(updateCalendarView);
  };

  useEffect(() => {
    const generateCalendarRunner = async () => {
      handleCalendarView("");
      const { calendarMatrix, updatedDateFlags } = await generateCalendar();
      dateFlags.current = updatedDateFlags;
      updateCalendar({ calendarMatrix });
    };
    generateCalendarRunner();
  }, [calendarCurrentMonth, studentId]);

  return (
    <div style={styles.container}>
      <div style={styles.calendarHeader}>
        <ChevronLeft
          color="#000000"
          onClick={() =>
            displayPreviousMonth({ calendarCurrentMonth, calendarCurrentYear })
          }
        />
        <p style={styles.calendarHeaderData}>
          {MONTHS[calendarCurrentMonth]} &nbsp; {calendarCurrentYear}
        </p>
        <ChevronRight
          name="chevron-forward"
          color="#000000"
          onClick={() =>
            displayNextMonth({ calendarCurrentMonth, calendarCurrentYear })
          }
        />
      </div>

      <CalendarHeader />
      {calendarView ? (
        <div style={styles.calendarView}>{calendarView}</div>
      ) : (
        <Loading />
      )}
    </div>
  );
});
